<template>
  <div>
    <div class="sliderContainer">
      <h1
        style="
          text-align: center;
          font-weight: 800;
          font-size: 40px;
          color: #b5aaa3;
          text-shadow: 0 2px 2px #444;
        "
      >
        {{ $t("categoriesTitle") }}
      </h1>
      <div
        id="categoryCarousel"
        class="carousel slide"
        data-bs-ride="carousel"
      >
        <div class="carousel-inner">
          <div
            class="carousel-item"
            v-for="(categoryGroup, index) in categoryGroups"
            :key="index"
            :class="{ active: index === 0 }"
            style="min-width: 30%"
          >
            <div class="row">
              <div
                class="col-md-4"
                v-for="category in categoryGroup"
                :key="category.id"
                style="min-width: 150px"
              >
                <a
                  :href="`/products?categoryID=${category.id}`"
                  style="text-decoration: none"
                >
                  <div class="card cardSlider">
                    <img
                      :src="
                        category.imagee
                      "
                      class="cardImg"
                      :alt="category.name"
                    />
                    <div class="card-body card-body-slider">
                      <h5 class="card-title">{{ category.name }}</h5>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <button
          class="carousel-control-prev light"
          type="button"
          data-bs-target="#categoryCarousel"
          data-bs-slide="prev"
        >
          <span
            class="carousel-control-prev-icon light"
            aria-hidden="true"
          ></span>
          <span class="visually-hidden light">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#categoryCarousel"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
      <a href="/categories">
        <button class="button-89" role="button">{{ $t("seeMore") }}</button>
      </a>

      <div v-if="categories.length === 0" class="noCategories">
        <p>{{$t('noCategories')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "../../Axios";
import bootstrap from "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default {
  name: "categories",
  data() {
    return {
      categories: [],
      windowWidth: window.innerWidth
    };
  },
  computed: {
    categoryGroups() {
      // console.log(this.windowWidth );
      const groups = [];
      if (this.windowWidth  >= 770) {
        for (let i = 0; i < this.categories.length; i += 3) {
          groups.push(this.categories.slice(i, i + 3));
        }
      } else {
        for (let i = 0; i < this.categories.length; i += 1) {
          groups.push(this.categories.slice(i, i + 1));
        }
      }
      return groups;
    },
  },
  methods:{
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted() {
    Axios
      .get("/category")
      .then((response) => {
        // console.log(response.data);
        this.categories = response.data.categories.map((category) => {
          if (category.imagee && category.imagee.type === 'Buffer' && Array.isArray(category.imagee.data)) {
            const buffer = Buffer.from(category.imagee.data);
            const base64Image = buffer.toString('base64');
            category.imagee = `data:image/jpeg;base64,${base64Image}`; // Adjust MIME type if needed
          }
          return { ...category };
        });
      })
      .catch((error) => {
        // console.log(error);
      });

    this.$nextTick(() => {
      new bootstrap.Carousel(document.getElementById("categoryCarousel"), {
        interval: false,
      });
    });
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
};
</script>

<style scoped>
.sliderContainer {
  background-image: url("../../assets/images/sliderBG.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-top: 30px;
  padding-top: 60px;
}

.cardSlider {
  border: none;
  height: 300px;
  border-radius: 15px;
  background-color: #f3f1f0c6;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  margin-top: 60px;
  margin-top: 30px;
}

.cardImg {
  width: 100%;
  height: 200px;
  transition: transform 0.2s ease-in-out;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  margin-bottom: 20px;
}

.cardImg:hover {
  transform: scale(1.02);
}

.card-title {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}

.card-title:hover {
  color: #fcc848;
}

.noCategories {
  margin-left: 45%;
  width: 50%;
  margin-top: 20px;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  filter: invert(1) sepia(0) saturate(1) hue-rotate(0deg);
}

.carousel-inner {
  padding-left: 15%;
  padding-right: 15%;
}

.card-body-slider {
  display: flex;
  flex-direction: column;
}

.button-89 {
  --b: 3px;
  --s: 0.45em;
  --color: #72706e;
  font-weight: 800;
  margin-right: 46%;
  margin-bottom: 50px;
  margin-top: 20px;

  padding: calc(0.5em + var(--s)) calc(0.9em + var(--s));
  color: var(--color);
  --_p: var(--s);
  background: conic-gradient(
      from 90deg at var(--b) var(--b),
      #0000 90deg,
      var(--color) 0
    )
    var(--_p) var(--_p) / calc(100% - var(--b) - 2 * var(--_p))
    calc(100% - var(--b) - 2 * var(--_p));
  transition: 0.3s linear, color 0s, background-color 0s;
  outline: var(--b) solid #0000;
  outline-offset: 0.6em;
  font-size: 16px;

  border: 0;

  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-89:hover,
.button-89:focus-visible {
  --_p: 0px;
  outline-color: var(--color);
  outline-offset: 0.05em;
}

.button-89:active {
  background: var(--color);
  color: #fff;
}

@media (max-width: 770px) {
  .carousel-inner {
    padding-left: 10%;
    padding-right: 10%;
  }

  .col-md-3 {
    flex-basis: 5%;
    max-width: 30%;
  }
}
</style>
